import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input, booleanAttribute} from '@angular/core';

@Component({
  selector: 'app-empty-list',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './empty-list.component.html',
  styleUrl: './empty-list.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyListComponent {
  @Input() name: string = 'dato'
  @Input() message: string = `Nessun ${this.name} trovato :(`;
  @Input() hint: string = '';
  @Input({ transform: booleanAttribute }) withImage: boolean = true;
}
